import { Link, Modal, Text } from "@shopify/polaris"
import { Trans, useTranslation } from "react-i18next"

const REPLACE_TRACKING_PAGE_HELP_DOC_URL = "https://docs.parcelpanel.com/shopify/notifications/add-tracking-link-shopify/"

interface ReplaceTrackingPageModalProps {
  open: boolean
  loading?: boolean
  onClose: () => void
  onReplace: () => void
}

const ReplaceTrackingPageModal = ({
  open,
  loading = false,
  onClose,
  onReplace,
}: ReplaceTrackingPageModalProps) => {
  const { t } = useTranslation(["dashboard", "common"])

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={t("dashboard:ReplaceTrackingPage")}
      primaryAction={{
        content: t("dashboard:ReplaceTrackingPageAction"),
        onAction: onReplace,
        loading,
      }}
    >
      <Modal.Section>
        <Text as={"p"} variant={"bodyMd"} fontWeight={"medium"}>
          {t("dashboard:ReplaceTrackingPageDetectedDescription")}
        </Text>
        <div className={"mt-3"} />
        <Text as={"p"} variant={"bodyMd"}>
          {t("dashboard:ReplaceTrackingPageNote")}
        </Text>
        <div className={"mt-1"} />
        <Text as={"p"} variant={"bodyMd"} tone={"subdued"}>
          <Trans ns={"dashboard"} i18nKey={"ReplaceTrackingPageHelpDoc"}>
            <Link
              url={REPLACE_TRACKING_PAGE_HELP_DOC_URL}
              target={"_blank"}
              removeUnderline
              external
            />
          </Trans>
        </Text>
      </Modal.Section>
    </Modal>
  )
}

export default ReplaceTrackingPageModal
